import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {OAuthService} from "angular-oauth2-oidc";
import {Router} from "@angular/router";
import {AppTokenService} from "@synx-cloud/services";

@Component({
    selector: "app-header",
    templateUrl: "./app-header.component.html",
    styleUrls: ["./app-header.component.scss"],
    standalone: false
})
export class AppHeaderComponent implements OnInit {

    /**
     * CTOR
     * @param oAuthService
     * @param router
     */
    constructor(private oAuthService: OAuthService,
                public router: Router,
                private appTokenService: AppTokenService) {
    }

  @Input()
  helpToggled: boolean;

  @Output()
  helpToggledChange = new EventEmitter<boolean>();

  isUserMenuOpen = false;

    isTabActive(tabToCheck: string): boolean {
        return this.router.url.includes(tabToCheck);
    }

    /**
     * On Init
     */
    ngOnInit() {
    }

    /**
     * A function to navigate the user to the home screen.
     */
    gotoHome() {
        this.router.navigate(["landing"]);
    }

    /**
     * A Function to navigate the user to the admin page.
     */
    gotoAdmin() {
        this.router.navigate(["admin/admin-landing"]);
    }

    /**
     * A Function to navigate the user to the profile page.
     */
    gotoProfile() {
        this.router.navigate(["profile"]);
    }

    /**
     * Makes a call to identityserver to logout
     */
    logout() {
        this.oAuthService.logOut();
        this.appTokenService.clear();
        this.oAuthService.revokeTokenAndLogout();
    }

    /**
     * A Function to navigate the user to the global settings page.
     */
    gotoGlobalSettings() {
        this.router.navigate(["global-settings"]);
    }

  /**
   * Toggles the help modal
   */
  toggleHelp(force: boolean) {
    if (force != null) {
      this.helpToggled = force;
    } else {
      this.helpToggled = !this.helpToggled;
    }
    this.helpToggledChange.emit(this.helpToggled);
  }
}
